import Reveal from './Reveal';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-tv-line',
      title: '企業VP / CM / 音声ファイル/ 映像作品のMA',
      description: '企業のプロモーション映像やCMの音響制作を一貫してサポート'
    },
    {
      icon: 'ri-film-line',
      title: '映画・映像作品のMA・効果音',
      description: '映画や映像作品のMA作業、効果音制作で作品の魅力を最大化'
    },
    {
      icon: 'ri-presentation-line',
      title: '展示会・イベント映像音響',
      description: '展示会やイベントでの映像音響で、空間全体を演出',
      hoverDescription: '大阪関西万博のパビリオンに参加した実績をもとに、お客様のイメージを具現化するお手伝いをします。'
    },
    {
      icon: 'ri-mic-line',
      title: 'AIナレーション制作',
      description: '最新のAI技術を活用した高品質なナレーション制作',
      hoverDescription: '商用可能なAIを駆使し、28年の実績を持つエンジニアが、映像に合わせ適切にタイミングなど調整編集します。'
    },
    {
      icon: 'ri-record-circle-line',
      title: 'ロケーション録音',
      description: '現場での録音から編集まで、出張対応で柔軟にサポート',
      hoverDescription: 'TVCMや企業映像、インタビュー動画等、動画撮影の録音に対応します。'
    },
    {
      icon: 'ri-edit-line',
      title: '出張編集',
      description: 'お客様の環境での編集作業も対応可能',
      hoverDescription: '弊社エディターが、他社ポストプロダクション、制作会社など、場所を問わずどこでもお伺いし、編集させて頂きます。お気軽にお問い合わせください。'
    }
  ];

  return (
    <section id="services" className="py-24 md:py-32 bg-site-dark">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <Reveal>
          <div className="text-center mb-20">
            <p className="eyebrow text-teal-400 text-sm md:text-base mb-4">Services</p>
            <h2 className="text-3xl md:text-5xl font-mincho text-white mb-6">業務内容</h2>
            <div className="w-20 h-[3px] bg-teal-400 mx-auto mb-6 rounded-full"></div>
            <p className="text-xl text-zinc-400 max-w-3xl mx-auto">
              1人のクリエイターがすべての工程を一貫して担当。<br />
              スピーディかつ柔軟に対応できる点が強みです。
            </p>
          </div>
          </Reveal>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <Reveal key={index} variant="fly" direction="up" delay={(index % 3) * 90}>
              <div className="bg-white/[0.03] border border-white/10 rounded-xl p-7 hover:border-teal-400/40 hover:bg-teal-500/5 transition-all group cursor-pointer h-full">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-500/10 rounded-lg mb-4 group-hover:bg-teal-500 transition-colors">
                  <i className={`${service.icon} text-2xl text-teal-300 group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-xl font-medium text-white mb-3">{service.title}</h3>
                <p className="text-zinc-400 leading-relaxed group-hover:hidden transition-opacity">
                  {service.description}
                </p>
                {service.hoverDescription && (
                  <p className="text-zinc-400 leading-relaxed hidden group-hover:block transition-opacity">
                    {service.hoverDescription}
                  </p>
                )}
              </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-16 text-center">
            <div className="bg-teal-500 text-white p-8 md:p-10 rounded-xl">
              <h3 className="text-2xl font-mincho mb-4">対応ジャンル</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-4xl mx-auto">
                <div className="flex items-center">
                  <i className="ri-check-double-line mr-3 text-teal-100"></i>
                  企業VP / CM / 音声ファイル/ 映像作品のMA
                </div>
                <div className="flex items-center">
                  <i className="ri-check-double-line mr-3 text-teal-100"></i>
                  映画・映像作品のMA・効果音
                </div>
                <div className="flex items-center">
                  <i className="ri-check-double-line mr-3 text-teal-100"></i>
                  展示会・イベント映像音響
                </div>
                <div className="flex items-center">
                  <i className="ri-check-double-line mr-3 text-teal-100"></i>
                  AIナレーション制作
                </div>
                <div className="flex items-center">
                  <i className="ri-check-double-line mr-3 text-teal-100"></i>
                  ロケーション録音 / 出張編集
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}